import React, { useEffect, useState } from 'react';
import { staffApi } from './api';
import { isStaff } from './access';
export default function SessionGate({ children }) {
  const user = JSON.parse(sessionStorage.getItem('user') || 'null');
  const staff = isStaff(user);
  const [ready, setReady] = useState(!staff);
  const [error, setError] = useState('');
  const [version, setVersion] = useState(0);
  useEffect(() => {
    if (!staff) return;
    let alive = true;
    async function refresh() {
      try {
        const current = await staffApi('/me');
        if (!alive) return;
        const previous = sessionStorage.getItem('user');
        sessionStorage.setItem('user', JSON.stringify(current));
        if (previous !== JSON.stringify(current)) setVersion(value => value + 1);
        setError(''); setReady(true);
      } catch (failure) { if (alive) { setReady(false); setError(failure.message); } }
    }
    refresh();
    const timer = setInterval(refresh, 15000);
    window.addEventListener('focus', refresh);
    return () => { alive = false; clearInterval(timer); window.removeEventListener('focus', refresh); };
  }, [staff]);
  if (!ready) return <div className="p-5" role="status">{error || 'Checking your menu access…'} {error && <a href="/auth-login">Sign in again</a>}</div>;
  return <React.Fragment key={version}>{children}</React.Fragment>;
}
